$(document).ready(function() {
	$('.js-header-search-trigger').on('click', function(e) {
		e.preventDefault();
		$('.js-modal-search').addClass('modal-search--visible');
		$('body').addClass('no-scroll');
	})

	$('.js-modal-search-close').on('click', function(e) {
		e.preventDefault();
		$('.js-modal-search').removeClass('modal-search--visible');
		$('body').removeClass('no-scroll');
	});

	$(document).on('click', '.js-modal-search', function(e) {
		if (e.target === this) {
			$('.js-modal-search').removeClass('modal-search--visible');
			$('body').removeClass('no-scroll');
		}
	});
});
